import { render } from "./SearchSuggestions.vue?vue&type=template&id=01f3e8ed"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"

import "./SearchSuggestions.vue?vue&type=style&index=0&id=01f3e8ed&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__